import { render } from "./ChatsList.vue?vue&type=template&id=18286a46&scoped=true"
import script from "./ChatsList.vue?vue&type=script&lang=js"
export * from "./ChatsList.vue?vue&type=script&lang=js"

import "./ChatsList.vue?vue&type=style&index=0&id=18286a46&lang=scss&scoped=true"

import exportComponent from "G:\\Programming\\VueProjects\\radinrealp2p\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18286a46"]])

export default __exports__